import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrudProducts = () => import('./staff/crudProducts')
const ViewStaffCrudProductsMarketplace = () => import('./staff/crudProductsMarketplace')
const ViewStaffCrudProductsWeb = () => import('./staff/crudProductsWeb')
const ViewStaffCrudProductsCompound = () => import('./staff/crudProductsCompound')
const ViewStaffCrudCategories = () => import('./staff/crudCategories')
const ViewStaffCrudLines = () => import('./staff/crudLines')
const ViewStaffCrudColors = () => import('./staff/crudColors')
const ViewStaffCrudWaist = () => import('./staff/crudWaist')
const ViewStaffCrudContactInterested = () => import('./staff/crudContactInterested')
const ViewStaffSummaryContactSold = () => import('./staff/summaryContactSold')
const ViewStaffCrudUnitMeasurement = () => import('./staff/crudUnitMeasurement')
const ViewStaffPrintLabels = () => import('./staff/printLabels')
const ViewStaffPriceAudit = () => import('./staff/priceAudit')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'ProductsStaffDashboard',
  crudProducts: 'ProductsStaffCrudProducts',
  crudProductsMarketplace: 'ProductsStaffCrudProductsMarketplace',
  crudProductsWeb: 'ProductsStaffCrudProductsWeb',
  crudCategories: 'ProductsStaffCrudCategories',
  crudItems: 'ProductsStaffCrudLines',
  crudColors: 'ProductsStaffCrudColors',
  crudWaist: 'ProductsStaffCrudWaist',
  crudContactInterested: 'ProductsStaffCrudContactInterested',
  summaryContactSold: 'ProductsStaffSummaryContactSold',
  crudProductsCompound: 'ProductsStaffCrudProductsCompound',
  crudUnitMeasurement: 'ProductsStaffCrudUnitMeasurement',
  printLabels: 'ProductsStaffPrintLabels',
  priceAudit: 'ProductsStaffPriceAudit',
}

const router =
  [
    {
      path: '/st/products',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Productos',
          }
        },  
        {
          path: 'products',
          name: VIEWS.crudProducts,
          component: ViewStaffCrudProducts,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'ABM Productos',
          }
        },  
        {
          path: 'productsMarketplace',
          name: VIEWS.crudProductsMarketplace,
          component: ViewStaffCrudProductsMarketplace,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'ABM Productos - Marketplace',
          }
        },
        {
          path: 'productsWeb',
          name: VIEWS.crudProductsWeb,
          component: ViewStaffCrudProductsWeb,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'ABM Productos - Web',
          }
        },
        {
          path: 'categories',
          name: VIEWS.crudCategories,
          component: ViewStaffCrudCategories,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'ABM Categorías de Productos',
          }
        },  
        {
          path: 'lines',
          name: VIEWS.crudItems,
          component: ViewStaffCrudLines,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'ABM Líneas de Productos',
          }
        },                    
        {
          path: 'colors',
          name: VIEWS.crudColors,
          component: ViewStaffCrudColors,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'ABM Colores de Productos',
          }
        },   
        {
          path: 'waist',
          name: VIEWS.crudWaist,
          component: ViewStaffCrudWaist,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'ABM Talles de Productos',
          }
        },         
        {
          path: 'marketplace/:productID',
          name: VIEWS.crudContactInterested,
          component: ViewStaffCrudContactInterested,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Marketplace - Interesados',
          }
        },     
        {
          path: 'marketplace/report/summary',
          name: VIEWS.summaryContactSold,
          component: ViewStaffSummaryContactSold,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Marketplace - Resumen de Ventas',
          }
        },  
        {
          path: 'productsCompound',
          name: VIEWS.crudProductsCompound,
          component: ViewStaffCrudProductsCompound,
          beforeEnter: Permisos.IS_PERSONAL,

        },          
        {
          path: 'unitMeasurement',
          name: VIEWS.crudUnitMeasurement,
          component: ViewStaffCrudUnitMeasurement,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'ABM Unidades de Medida',
          }
        },
        {
          path: 'labels',
          name: VIEWS.printLabels,
          component: ViewStaffPrintLabels,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Impresión de Etiquetas',
          }
        },
        {
          path: 'price-audit',
          name: VIEWS.priceAudit,
          component: ViewStaffPriceAudit,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Auditoría de Precios',
          }
        },
      ]
    },

    {
      path: '/cu/products',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/products',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
